export * from './admin-glossary-edit.component';
